import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "..";
import runningHttpClient from "../../axios";
import { EmojiDomain, StoryCommentDomain } from "../../models/commonModels";
import { UpdateStoryItem } from "../lenta-slice/LentaSlice";
interface InitSt{
    isFeatching:boolean,
    comments:StoryCommentDomain[],
    reactions:string[],
    userReactions:EmojiDomain[]
}

const initSt:InitSt={
    isFeatching:false,
    comments:[],
    reactions:[],
    userReactions:[]
}
const CommentSlice = createSlice({
    name:"CommentSlice",
    initialState:initSt,
    reducers:{
        fetching(state, action:PayloadAction<boolean>){
            state.isFeatching=action.payload;
        },
        fetchComments(state,action:PayloadAction<StoryCommentDomain[]>){
            state.comments=action.payload
        },
        fetchRections(state, action:PayloadAction<string[]>){
            state.reactions=action.payload
        },
        fetchUserReactions(state, action:PayloadAction<EmojiDomain[]>){
            state.userReactions=action.payload
        }
    }
})

export const {
    fetching,
    fetchComments,
    fetchRections,
    fetchUserReactions
}=CommentSlice.actions

export default CommentSlice.reducer;

export const getComments = (storyId:number)=> async (dispatch:AppDispatch)=>{
    dispatch(fetching(true))
    try{
        const res = await runningHttpClient.get<StoryCommentDomain[]>('api/v1/story/comment', {params:{story_id:storyId}})
        if(res.status===200){
            dispatch(fetchComments(res.data))
        }
    }catch{

    }finally{
        dispatch(fetching(false))
    }
}

export const sendComment=(storyId:number|null, msg:string, cId:number|null) =>async (dispatch:AppDispatch)=>{
    if(storyId==null)return
    dispatch(fetching(true));
    const data = {
        a_id:storyId,
        message:msg,
        c_id:cId,
    }
    try{
        const res = await runningHttpClient.post('api/v1/story/comment', data)
        if(res.status===200){
            dispatch(getComments(storyId))
            dispatch(UpdateStoryItem(storyId))
        }
    }catch(e){

    }finally{
        dispatch(fetching(false))
    }
}

export const deleteComment=(storyId:number|null, dataDelete:StoryCommentDomain)=>async(dispatch:AppDispatch)=>{
if(storyId==null)return
    dispatch(fetching(true));
    
    try{
        const res = await runningHttpClient.delete('api/v1/story/comment', {data:dataDelete})
        if(res.status===200){
            dispatch(getComments(storyId))
            dispatch(UpdateStoryItem(storyId))
        }
    }catch(e){

    }finally{
        dispatch(fetching(false))
    }
}

export const getReactions =() =>async (dispatch:AppDispatch)=>{
    try{
        const res = await runningHttpClient.get('api/v1/reaction/get');
        if(res.status===200){
            dispatch(fetchRections(res.data))
        }
    }catch(e){

    }
}


export const getReactionsArr = (storyId:number) => async(dispatch:AppDispatch)=>{
    try{
        const res = await runningHttpClient.get<EmojiDomain[]>('api/v1/reaction', {params:{
                story_id:storyId
            }})
            if(res.status===200)dispatch(fetchUserReactions(res.data))
    }catch(e){

    }finally{

    }
    
}

